import React from 'react';
import { useTranslation } from '../../i18n';

interface BackButtonProps {
  onClick: () => void;
}

export const BackButton: React.FC<BackButtonProps> = ({ onClick }) => {
  const t = useTranslation();
  return (
    <button
      onClick={onClick}
      className="absolute top-8 left-4 text-[8px] lg:text-xs text-gray-500 hover:text-theme transition-colors z-10"
    >
      {t.back}
    </button>
  );
};
